import { ComponentType } from 'react';
import Spin from '@stripcash/ui-kit/components/Spin';

import DynamicImport from 'common/components/DynamicImport';

import restrict from './restrict';

const getPageComponent = <T extends {}>(
  loadComponent: () => Promise<
    { default: ComponentType<T> } | ComponentType<T>
  >,
) =>
  restrict((props: T) => (
    <DynamicImport load={loadComponent}>
      {(Component) =>
        Component === null ? (
          <Spin element="div" spin />
        ) : (
          <Component {...props} />
        )
      }
    </DynamicImport>
  ));

export default getPageComponent;
